import React, { useEffect, useRef, useCallback, useMemo } from "react";
import { useSearchStore } from "@/entities/search/model";
import { loadMore } from "@/entities/search/model/load-more";
import { ChatListItem } from "../chat-list";
import { MessageItem } from "./message-item";
import { Spinner } from "react-bootstrap";
import { Chat, useChatStore } from "@/entities/chat";
import { Contact } from "@/entities/contact";
import { AnimatePresence } from "framer-motion";
import { motion } from "framer-motion";

export interface SearchResultsListProps {
  userId: string;
  currentChatId?: string;
  onSelectChat: (chat: Chat) => void;
  getCurrentChatName: (contact: Contact | undefined) => string;
  onSelectMessage: (chatId: string, messageId: string) => void;
}

export const SearchResultsList = ({ userId, currentChatId, onSelectChat, getCurrentChatName, onSelectMessage }: SearchResultsListProps) => {
  const { chats, loadingMore, searchQuery } = useSearchStore();
  const containerRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container || loadingMore) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollHeight - scrollTop - clientHeight < 200) {
      loadMore();
    }
  }, [loadingMore]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  const selectedChats = useChatStore((state) => state.selectedChats);

  const hasUnread = useMemo(() => selectedChats.some((chatId) => {
    const chat = chats.find(c => c._id === chatId);
    return chat ? chat.isReaded === false || chat.unreadedMessageCount > 0 : false;
  }), [selectedChats]);

  const hasRead = useMemo(() => selectedChats.some((chatId) => {
    const chat = chats.find(c => c._id === chatId);
    return chat ? (chat.isReaded === undefined || chat.isReaded === true) && chat.unreadedMessageCount === 0 : false;
  }), [selectedChats]);


  return (
    <div ref={containerRef} style={{ overflowY: "auto", height: "100%" }}>
      <AnimatePresence>
        {chats.map(chat => (
          <motion.div
            key={chat._id}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={itemVariants}
            transition={{ duration: 0.2 }}
          >
            <ChatListItem
              chat={chat}
              userId={userId}
              hasUnread={hasUnread}
              hasRead={hasRead}
              selectedChats={selectedChats}
              currentChatId={undefined}
              onSelectChat={onSelectChat}
              onSelectChats={(chatId) =>{}}
              getCurrentChatName={getCurrentChatName}
            />
          </motion.div>
        ))}
      </AnimatePresence>

      {/* {
        messages.length > 0 &&
        <div style={{ width: "100%", backgroundColor: "#cccccc63", fontSize: 12, marginTop: 6, marginBottom: 2, padding: "2px 8px", color: "gray" }}>
          Найдено {messages.length} {messages.length === 1 ? "сообщение" : "сообщений"}
        </div>
      }

      <AnimatePresence>
        {messages.map(msg => (
          <motion.div
            key={msg._id}
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={itemVariants}
            transition={{ duration: 0.2 }}
          >
            <MessageItem message={msg} query={searchQuery} onSelectMessage={onSelectMessage} />
          </motion.div>
        ))}
      </AnimatePresence> */}

      {loadingMore && (
        <div className="d-flex justify-content-center p-2">
          <Spinner size="sm" animation="border" />
        </div>
      )}


      {/* // {!loadingMore && chats.length < 1 && messages.length < 1 && ( */}
      {!loadingMore && chats.length < 1 && (
        <div style={{ textAlign: "center", color: "gray" }}>
          Нет результатов
        </div>
      )}
    </div>
  );
};
